const convertToFloat = (value) => {
  if (!value) return 0;
  return Number.parseFloat(value).toFixed(2);
};

export default convertToFloat;
